import { BreadcrumbConfig } from '@components/molecules/breadcrumbs/models/breadcrumb';
import { DynamicOptionsParams } from '@components/molecules/breadcrumbs/services/breadcrumbs.service';

import { AccessContext, AccessStrategy, WidgetConfig } from '@shared/services';

export class NoneAccessStrategy implements AccessStrategy {
	getWidgets(_: AccessContext): WidgetConfig[] {
		return [];
	}

	private buildBaseBreadcrumbs(): BreadcrumbConfig {
		return { levels: [] };
	}

	async getBreadcrumbs(_: AccessContext): Promise<[BreadcrumbConfig, DynamicOptionsParams[]]> {
		const baseConfig = this.buildBaseBreadcrumbs();

		return [baseConfig, []];
	}

	canAccess(): boolean {
		return false;
	}
}
